export default __webpack_public_path__ + "static/loader-circle-a47fed4fafc96c49cdd1b53e3fdc2b30.gif";